export const AUTH = {
  loginForm: "login-form",
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-button",
  registerForm: "register-form",
  registerName: "register-name-input",
  registerEmail: "register-email-input",
  registerPassword: "register-password-input",
  registerSubmit: "register-submit-button",
  switchToRegister: "switch-to-register-link",
  switchToLogin: "switch-to-login-link",
};

export const DASHBOARD = {
  container: "dashboard-container",
  sidebar: "dashboard-sidebar",
  mapView: "map-view",
  propertyList: "property-list",
  addPropertyButton: "add-property-button",
  themeToggle: "theme-toggle-button",
  logoutButton: "logout-button",
};

export const PROPERTY = {
  card: "property-card",
  marker: "property-marker",
  detailsDrawer: "property-details-drawer",
  editButton: "property-edit-button",
  deleteButton: "property-delete-button",
  form: "property-form",
  titleInput: "property-title-input",
  descriptionInput: "property-description-input",
  priceInput: "property-price-input",
  locationInput: "property-location-input",
  categorySelect: "property-category-select",
  submitButton: "property-submit-button",
};

export const AI = {
  analyzeButton: "ai-analyze-button",
  analysisPanel: "ai-analysis-panel",
  responseArea: "ai-response-area",
  selectPropertyCheckbox: "select-property-checkbox",
};

export const HOME = {
  emergentLink: "emergent-link",
};